<script>
  import { onMount } from 'svelte';
  import { domainName, selector, record } from '../stores.js';

  let key = '';
  let keyParts = [];
  let keyVersion = '';
  let keyPublicKey = '';
  let keyType = '';
  let keyLength = 0;

  onMount(() => {
    key = $record.key;
    // Deep breakdown of the DKIM key.
    keyParts = key.split(/[;]/).map(v => v = v.trim())
      .reduce((parts, curr) => {
        let v = curr.split(/[=]/);
        parts[v[0]] = v[1];
        return parts;
      }, {});

    if (keyParts.v) {
      keyVersion = keyParts.v;
    }
    if (keyParts.p) {
      keyPublicKey = keyParts.p;
    }
    if (keyParts.k) {
      keyType = keyParts.k;
    }
    if ($record.key_length) {
      keyLength = $record.key_length;
    }
  });
</script>

<div class="record-box record-tags">
  <div id="headingRaw" class="box-label">
    <h5>Additional Results</h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseTags" aria-expanded="true" aria-controls="collapseTags" aria-label="Close"></button>
  </div>
  <div id="collapseTags" class="box-detail collapse show" aria-labelledby="headingRaw">
    <table class="table table-bordered">
      <tbody>
        {#if keyLength != 0}
          <tr>
            <td>Length of This Key</td>
            <td>{keyLength}</td>
          </tr>
        {/if}
        {#if keyVersion != ''}
          <tr>
            <td>Version of This Key</td>
            <td>{keyVersion}</td>
          </tr>
        {/if}
        {#if keyPublicKey != ''}
          <tr>
            <td>Public Key</td>
            <td>
              -----BEGIN PUBLIC KEY-----<br />
              {keyPublicKey}<br />
              -----END PUBLIC KEY-----
            </td>
          </tr>
        {/if}
        {#if keyType != ''}
          <tr>
            <td>Key Type</td>
            <td>{keyType}</td>
          </tr>
        {/if}
      </tbody>
    </table>
  </div>
</div>

<style>
td:first-child {
  width: 30%;
}
</style>
